import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';
import { Container } from '@/components/Grid';

export const HeroSection = styled.header`
  position: relative;
  overflow: hidden;
  background: radial-gradient(
    ellipse 78% 68% at 26% 28%,
    #0f555c 0%,
    #0c3f45 21%,
    #0a282d 42%,
    ${homeColor.bg} 86%
  );
`;

export const HeroInner = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 40px 0;

  ${screen.lg} {
    gap: 40px;
  }
`;

export const HeroTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;

  ${screen.lg} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
  }
`;

export const HeroCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 640px;
  text-align: center;

  ${screen.lg} {
    text-align: left;
  }
`;

export const Eyebrow = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  color: ${homeColor.green};
  font-size: 12px;
  letter-spacing: 0.13em;
  margin: 0;
`;

export const HeroTitle = styled.h1`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.08;
  font-size: 50px;
  margin: 0;
  color: ${homeColor.white};
`;

export const HeroSub = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 17px;
  line-height: 1.6;
  color: ${homeColor.muted};
  margin: 0;

  b {
    color: ${homeColor.white};
    font-weight: 600;
  }
`;

export const CtaRow = styled.div`
  display: flex;
  justify-content: center;

  ${screen.lg} {
    justify-content: flex-start;
  }
`;

export const HeroImageWrap = styled.div`
  flex: none;
  width: 100%;
  max-width: 460px;
`;
